import axios from '@_system/axios/axios.js'
export default {
	path: '/reconciliationcurrent',
	list(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	save(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	get(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	update(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.put(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	delete(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.delete(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	settlement(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/settlement', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	setMkCode(id,data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/setMkCode/'+id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},	
	getPaymentInfo(data){
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getPaymentInfo', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	getReceiptInfo(data){
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getReceiptInfo', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	payment(data){
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/payment', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	sendReceipt(data){
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/sendReceipt', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	reflashDownloadNo(id,data){
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/reflashDownloadNo/'+id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	copyBycode(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/copyBycode', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	getrelationCode(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getrelationCode', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	// checkavailable(data = {}) {
	// 	return new Promise((resolve, reject) => {
	// 		axios.post(this.path + '/checkavailable', data, (res) => {
	// 			resolve(res.data)
	// 		}, reject)
	// 	})
	// },
	
	init(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get('moduleConfig/admin/reconciliationcurrent.reconciliationcurrent', data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},

	// saleorderimport(id, data = {}) {
	// 	return new Promise((resolve) => {
	// 		axios.post(this.path + '/saleorderimport/' + id, data, (res) => {
	// 			resolve(res.data)
	// 		})
	// 	})
	// },
	// saleorderexport(data = {}) {
	// 	return new Promise((resolve) => {
	// 		axios.post(this.path + '/saleorderexport', data, (res) => {
	// 			resolve(res.data)
	// 		})
	// 	})
	// },
}
